export const ActionTypes = {
  INITIALIZE: "INITIALIZE",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  BRANCH: "BRANCH",
  DEPARTMENT: "DEPARTMENT",
  ROLESLIST: "ROLESLIST",
  DESIGNATION: "DESIGNATION",
  STATE: "STATE",
  COUNTRY: "COUNTRY",
  CITY: "CITY",
  ZONE: "ZONE",
  LOADING: "LOADING",
  INVESTIGATION_DETAILS: "INVESTIGATION_DETAILS",
  SET_LAB_DEPT_ID: "SET_LAB_DEPT_ID",

  AREA_LIST_DROPDOWN: "AREA_LIST_DROPDOWN",
  STATE_LIST_DROPDOWN: "STATE_LIST_DROPDOWN",
  DOCTOR_LIST_DROPDOWN: "DOCTOR_LIST_DROPDOWN",
  COLLECTION_TYPE_LIST_DROPDOWN: "COLLECTION_TYPE_LIST_DROPDOWN",
  FRANCHISE_TYPE_LIST_DROPDOWN: "FRANCHISE_TYPE_LIST_DROPDOWN",
  FRANCHISE_LIST_DROPDOWN: "FRANCHISE_LIST_DROPDOWN",
  PAYMENT_MODE_LIST_DROPDOWN: "PAYMENT_MODE_LIST_DROPDOWN",
  INVESTIGATION_LIST_DROPDOWN: "INVESTIGATION_LIST_DROPDOWN",
  COLLECTION_BOY_LIST_DROPDOWN: "COLLECTION_BOY_LIST_DROPDOWN",
  DELIVERY_BOY_LIST_DROPDOWN: "DELIVERY_BOY_LIST_DROPDOWN",
  EMPLOYEE_LIST_DROPDOWN: "EMPLOYEE_LIST_DROPDOWN",
  ZONE_LIST_DROPDOWN: "ZONE_LIST_DROPDOWN",
  FRANCHISE_PACKAGE_LIST_DD_DROPDOWN: "FRANCHISE_PACKAGE_LIST_DD_DROPDOWN",
  DISCOUNT_REASON_LIST_DROPDOWN: "DISCOUNT_REASON_LIST_DROPDOWN",
  AGENT_LIST_DROPDOWN: "AGENT_LIST_DROPDOWN",

  SUBMIT_NEW_REGISTRATION: "SUBMIT_NEW_REGISTRATION",
  ClEAR_NEW_REGISTRATION: "ClEAR_NEW_REGISTRATION",
  DELETE_NEW_REGISTRATION: "DELETE_NEW_REGISTRATION",
  DELETE_PACKAGE_NEW_REGISTRATION: "DELETE_PACKAGE_NEW_REGISTRATION",

  BAR_CODE_INFO: "BAR_CODE_INFO",
  SUBMIT_REGISTRATION_SEARCH: "SUBMIT_REGISTRATION_SEARCH",
  CLEAR_REGISTRATION_SEARCH: "CLEAR_REGISTRATION_SEARCH",
  SUBMIT_APPOINTMENT_BOOKING_MASTER: "SUBMIT_APPOINTMENT_BOOKING_MASTER",
  RECEIPT_INFO: "RECEIPT_INFO",
  CLEAR_BAR_CODE_INFO: "CLEAR_BAR_CODE_INFO",

  LAB_DEPARTMENT_LIST_DROPDOWN: "LAB_DEPARTMENT_LIST_DROPDOWN",
  DEPARTMENT_LIST_DROPDOWN: "DEPARTMENT_LIST_DROPDOWN",
  STATUS_LIST_DROPDOWN: "STATUS_LIST_DROPDOWN",
  PACKAGE_LIST_DROPDOWN: "PACKAGE_LIST_DROPDOWN",
  SHOW_OBSERVATION_RANGE_FORM: "SHOW_OBSERVATION_RANGE_FORM",
  SET_OBSERVATION_RANGE_FORM_DATA: "SET_OBSERVATION_RANGE_FORM_DATA",
  SET_IS_INTERNAL_OBSERVATION_OPEN: "SET_IS_INTERNAL_OBSERVATION_OPEN",

  GET_BARCODE_IMAGE: "GET_BARCODE_IMAGE",
  ADD_NOTIFICATION: "ADD_NOTIFICATION",
  REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",
  MARK_AS_READ: "MARK_AS_READ",
  SET_LOADING: "SET_LOADING",

  SET_RESULT_ENTRY_OBSERVATIONS: "SET_RESULT_ENTRY_OBSERVATIONS",
  UPDATE_RESULT_ENTRY_OBSERVATION: "UPDATE_RESULT_ENTRY_OBSERVATION",
  RESET_RESULT_ENTRY_OBSERVATIONS: "RESET_RESULT_ENTRY_OBSERVATIONS",

  MEMBERSHIP_CARD_LIST_DROPDOWN: "MEMBERSHIP_CARD_LIST_DROPDOWN",
};
